











































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { stringUtil } from "@/models/stringUtil.ts";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    SvgIcon
  }
})
export default class LabelButton extends Vue {
  @Prop({ type: String, required: false }) icon!: string;
  @Prop({ type: String, default: "" }) label!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: String, required: false }) img!: string;
  @Prop({ type: Boolean, required: false }) toggled!: boolean;
  @Prop({ type: String, required: false }) svg!: string;
  @Prop({ type: Boolean, required: false }) absolute!: boolean;
  @Prop({ type: Object, required: false }) position!: any;
  @Prop({ type: String, required: false }) tooltip!: string;

  displayed = false;

  private get iconImg() {
    return this.img ? stringUtil.createDownloadUrl(this.img) : "";
  }

  private get iconSvg() {
    return this.svg ? stringUtil.createDownloadUrl(this.svg) : "";
  }

  private get top() {
    return this.position ? this.position.y : 0;
  }

  private get left() {
    return this.position ? this.position.x : 0;
  }

  private get isDisabled() {
    return this.displayed || !this.tooltip;
  }

  private onPopupHide() {
    this.displayed = true;
  }
}
